(() => {
  const callback = () => {
    const onAddToCart = () => {
      // Note: Event contains details about the product being added to the cart (event.detail.product)
      if (!window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;

      // Quantcast
      window._qevents = window._qevents || [];
      window._qevents.push({
        qacct: 'p-13Zmf4MpbcDw-',
        labels: '_fp.event.AddToCart Button',
        event: 'refresh',
      });
    };

    const onCheckoutStart = () => {
      if (!window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;

      // Quantcast
      window._qevents = window._qevents || [];
      window._qevents.push({
        qacct: 'p-13Zmf4MpbcDw-',
        labels: '_fp.event.Checkout Button',
        event: 'refresh',
      });
    };

    document.addEventListener('ajaxProduct:added', onAddToCart);
    document.addEventListener('checkout:started', onCheckoutStart);
  };

  document.addEventListener('DOMContentLoaded', callback);
})();
